import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { AuthShell, inputCls, btnCls } from "@/components/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) { setError(apiErr(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Choose a new password"
      footer={<Link to="/login" className="text-[#B87333] font-medium hover:underline" data-testid="reset-back-to-signin">Back to sign in</Link>}>
      {!token ? (
        <p className="text-red-600" data-testid="reset-no-token">This reset link is invalid or missing. Please request a new one.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div>
            <label className="text-sm font-medium text-[#2C2621]">New password</label>
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="reset-password" />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button type="submit" disabled={loading} className={btnCls} data-testid="reset-submit">{loading ? "Updating…" : "Update password"}</button>
        </form>
      )}
    </AuthShell>
  );
}
